import { createApp } from 'vue'
import App from './App.vue'
import "../node_modules/devextreme/dist/css/dx.light.css";
import "../node_modules/devexpress-richedit/dist/dx.richedit.css";
import router from "@/router";

const app = createApp(App).use(router);
app.mount('#app');
